import classNames from 'classnames';
import { Adventure } from '~/components/Adventure/Adventure.hooks';
import { AdventureFormik } from '~/components/Adventure/Form/AdventureFormik';
import { AdventureTooltip } from '~/components/Adventure/Tooltip/AdventureTooltip';
import { QueryErrorBoundary } from '~/components/Error';
import { T } from '~/components/I18n';
import { BottomSheet, BottomSheetProps } from '~/components/Modal/BottomSheet';
import styles from './AdventureBottomSheet.module.scss';

export type AdventureBottomSheetProps = Omit<BottomSheetProps, 'id'> & {
  id: Adventure['id'];
};

export const AdventureBottomSheet = ({
  className,
  id,
  onConfirm,
  onDismiss,
  ...props
}: AdventureBottomSheetProps) => (
  <BottomSheet
    className={classNames(styles.root, className)}
    title={
      <div className={styles.heading}>
        <T name="citizen_adventure_participatenum_title1" />
        <AdventureTooltip className={styles.tooltip} />
      </div>
    }
    // data-event="impression"
    // data-event-category="join_adventure_bottomsheet"
    // data-event-impression_id="{category}"
    onDismiss={onDismiss}
    onConfirm={onConfirm}
    {...props}>
    {({ dismiss, confirm }) => (
      <QueryErrorBoundary onReset={dismiss}>
        <AdventureFormik id={id} className={styles.form} onSubmit={confirm} />
      </QueryErrorBoundary>
    )}
  </BottomSheet>
);
